export const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const buildProductPayload = (product = {}) => ({
  name: String(product.name || "").trim(),
  slug: String(product.slug || "").trim() || slugify(product.name),
  description: String(product.description || "").trim(),
  price: Number(product.price) || 0,
  image_url: String(product.image_url || "").trim(),
  category: String(product.category || "").trim(),
  business_line: String(product.business_line || "Pantry").trim() || "Pantry",
  stock: Number(product.stock) || 0,
  featured: Boolean(product.featured),
  is_active: Boolean(product.is_active ?? true),
});
